import React, { Component } from "react";
import PropTypes from "prop-types";
import { LABEL_HEIGHT } from "../../pages/utils/common";
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js'; 
import { wrapLabel } from "./wrapLabel";

Chart.register(BarElement,BarController, CategoryScale, LinearScale, Title, Tooltip, Legend);
class HorizontalBarchartComponent extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    buildChart = () => {
        const myChartRef = this.chartRef.current.getContext("2d");
        this.chart = new Chart(myChartRef, {
            type: "bar",
            data: {
                labels: this.props.labels,
                datasets: [
                    {
                        label: this.props.label,
                        data: this.props.data,
                        backgroundColor: this.props.backgroundColors,
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1,
                indexAxis: 'y',
                onHover: (event, chartElements) => {
                    event.native.target.style.cursor = chartElements.length ? 'pointer' : 'default';
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true,
                        mode: 'nearest',
                        intersect: true
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        ticks: {
                            callback: function(value) { 
                                if (value % 1 === 0) { return value; }
                            }
                        }
                    },
                    y: {
                        ticks: {
                            callback: function(value, index) {
                                const labelValue = this.chart.data.labels[index];
                                return wrapLabel(String(labelValue), 45);
                            }
                        }
                    }
                }
            }
        });
    };

    chartClick = (evt) => {
        if (!this.chart) return;
        
        const points = this.chart.getElementsAtEventForMode(
            evt, 
            'nearest', 
            { intersect: true }, 
            false
        );
        
        if (points.length) {
            const firstPoint = points[0];
            const label = this.chart.data.labels[firstPoint.index];
            const value = this.chart.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
            
            this.props.legendCallBack(evt, {text: label, value});
        }
    };

    componentWillUnmount() {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    componentDidUpdate() {
        if (this.chart != null) {
            this.chart.destroy();
        }

        if (this.props.labels.length) {
            let factor = this.props.labels.length == 1 ? LABEL_HEIGHT.labelLargeHeight : this.props.labels.length <= 5 ? LABEL_HEIGHT.labelMediumHeight : LABEL_HEIGHT.labelSmallHeight;
            document.getElementById('myChart').style.height = this.props.labels.length * factor + 'px';
            this.buildChart();
        }
    }

    render() {
        return (
            <>
                <div className="wk-oberlay-body">
                    <canvas id="myChart" ref={this.chartRef} onClick={this.chartClick} />
                </div>
                <div className="legend">
                    {this.props.labels.map((item, i) => (
                        <div
                            className="legend-item"
                            key={item + i}
                            onClick={(evt) => this.props.legendCallBack(evt, { text: item })}
                        >
                            <div className="color" style={{ backgroundColor: this.props.backgroundColors[i] }} />
                            <span>{item}</span>
                        </div>
                    ))}
                </div>
            </>
        );
    }
}

HorizontalBarchartComponent.propTypes = {
    label: PropTypes.string.isRequired,
    labels: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    backgroundColors: PropTypes.array.isRequired,
    legendCallBack: PropTypes.func.isRequired,
};

export const HorizontalBarchart = HorizontalBarchartComponent;